
/**
 * 去除两边空格
 * 使用 <a-input xxxxx v-trim/>
 */
function getInput(el:any) {
  let inputEle
  if (el.tagName !== 'INPUT') {
    inputEle = el.querySelector('input')
  } else {
    inputEle = el
  }
  return inputEle
}
function dispatchEvent(el:any, type:any) {
  const evt = document.createEvent('HTMLEvents')
  evt.initEvent(type, true, true)
  el.dispatchEvent(evt)
}
const trim = {
  mounted (el:any) {
    const inputEle = getInput(el)
    const handler = function(event:any) {
      const newVal = event.target.value.trim()
      if (event.target.value !== newVal) {
        event.target.value = newVal
        dispatchEvent(inputEle, 'input')
      }
    }
    el.inputEle = inputEle
    el._blurHandler = handler
    inputEle.addEventListener('blur', handler)
  },
  unmounted(el:any) {
    console.log('el: ', el)
    const { inputEle } = el
    inputEle.removeEventListener('blur', el._blurHandler)
  }
}
export default trim
